//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableServer from '../../components/Table/Table.vue'
import { formatTime } from '../../components/helpers.js'

export default {
  name: 'ReportYandexTasks',
  components: {
    TableServer
  },
  props: {
    value: {
      type: Array,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    const columns = [{
      name: 'zoneExternalId',
      label: 'ID зоны'
    }, {
      name: 'executorYandexLogin',
      label: 'Логин исполнителя',
      labelTable: 'Логин</br>исполнителя'
    }, {
      name: 'executorFIO',
      label: 'ФИО исполнителя'
    }, {
      name: 'assignedEmployeeFIO',
      label: 'Пользователь учетной записи',
      labelTable: 'Пользователь</br>учетной записи'
    }, {
      name: 'brigadeName',
      label: 'Бригада'
    }, {
      name: 'brigadeEmployees',
      label: 'Состав бригады',
      format: value => {
        if (!value || !Array.isArray(value)) {
          return ''
        }
        return value.map(employee => employee.name || employee.fio).join(', ')
      }
    }, {
      name: 'subtaskId',
      label: 'ID подзадачи'
    }, {
      name: 'mountingPointExternalId',
      label: 'ID точки монтирования',
      labelTable: 'ID точки</br>монтирования'
    }, {
      name: 'subtaskType',
      label: 'Работа',
      format: value => value && value.name || ''
    }, {
      name: 'subtaskStatus',
      label: 'Статус подзадачи',
      labelTable: 'Статус</br>подзадачи',
      format: value => value && value.name || ''
    }, {
      name: 'subtaskUpdateStatusTime',
      label: 'Дата/время изменения статуса подзадачи',
      labelTable: 'Дата/время изменения</br>статуса подзадачи',
      format: value => formatTime(value)
    }, {
      name: 'subtaskComment',
      label: 'Комментарий исполнителя'
    }]

    for (const column of columns) {
      if (column.field == null) {
        column.field = column.name
      }
      if (column.align == null) {
        column.align = 'left'
      }
      if (column.sortable == null) {
        column.sortable = false
      }
    }

    return {
      columns: columns,
      pagination: {
        rowsPerPage: 0
      }
    }
  },
  computed: {
    itemsToShow: function () {
      return this.value || []
    }
  },
  methods: {
    getTrStyle: function (row) {
      return ''
    }
  }
}

